import React from 'react'
import { View } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'

const TableGrid = ({ children }) => {
  const tableGrid = {
    display: 'flex',
    flexDirection: 'row',
    padding: '0pt 5pt'
  }

  return <View style={[tableGrid]}>{children}</View>
}

export default TableGrid

TableGrid.propTypes = {
  children: PropTypes.node.isRequired
}
